import React, {useContext, useEffect, useRef, useState} from "react";
import ConnectorHeader from "./Components/ConnectorHeader";
import HorizontalLine from "./Components/HorizontalLine";
import Styles from './loadData/LoadData.module.scss'
import dataConnectorContext from "./context/dataConnectorContext";
import SelectBox from "../Componnets/SelectBox/SelectBox";
import Datepicker from "../Componnets/Datepicker/Datepicker";
import Button from "../Componnets/mainButton/Button";
import moment from 'jalali-moment'
import http from "../../services/api/utilities/http";

const LoadData = props => {
    const context = useContext(dataConnectorContext)
    const [loading, setLoading] = useState(false)
    const [loading1, setLoading1] = useState(false)
    const [assign, setAssign] = useState('admin')
    const [name, setName] = useState('')
    const [step, setStep] = useState(1)
    const [users, setUsers] = useState([])
    const [usersToShow, setUsersToShow] = useState([])
    const [username, setUsername] = useState(null)
    const [showDatepicker, setShowDatepicker] = useState(false)
    const [date, setDate] = useState(false)
    const [showNameGroupsPopup, setShowNameGroupsPopup] = useState(false)
    const [selectedUsers, setSelectedUsers] = useState([])
    // const [handleSetDate, setUsername] = useState(null)
    const {state, dispatch} = context

    const myRef = useRef();

    const handleClickOutside = e => {
        if (!myRef.current?.contains(e.target) && showNameGroupsPopup) {
            setShowNameGroupsPopup(false)
            setUsersToShow(users);
        }
    }

    useEffect(() => {
        document.addEventListener('mouseup', handleClickOutside);
        return () => document.removeEventListener('mouseup', handleClickOutside);
    })

    const handleSearchUsers = (e) => {
        const value = e.target.value.trim()
        if (value.length !== 0) {
            const filtered = users.filter(user => user.toLowerCase().includes(value.toLowerCase()));
            if (!filtered || filtered.length === 0) {
                setUsersToShow([]);
            } else {
                setUsersToShow(filtered);
            }
        } else {
            setUsersToShow(users)
        }
    }

    const sendDataPreview = (schedule = false) => {
       if(schedule){
           setLoading1(true)
       }else{
           setLoading(true)
       }
        let token = localStorage.getItem('token')
        let data = {
            name ,
            data_mapping:state.dataMapping,
        }

        let url = 'data_connector/data_pool_handler/'+state.connectorUid+'/'
        // let url = 'data_connector/data_pool_load/'+state.connectorUid+'/verify/'

        if(username) {
            data['to_user'] = username
            url = 'data_connector/data_pool_load/'+state.connectorUid+'/user_assignment/'
        }else{
            let time = moment.from(date[0], 'fa', 'YYYY-M-D')
                .format('YYYY-M-D');
        // .replace(/-0+/g, '-')
            data['start_now'] = !schedule
            data['datetime'] = schedule ? time+' '+date[1] : null
        }

        http[username ? 'post' : 'put'](url,data)
            .then(res => {
                console.log(res.data)
                props.getData()
                handleAssignDataPoolToUsers()
            })
            .catch(err=>{
                console.log(err.response)
                setLoading(false)
                setLoading1(false)
            })
    }

    useEffect(()=>getUser(),[])
    const getUser = () => {
        http.get('data_connector/data_pool_handler/assignable_users/')
            .then(res => {
                setUsers(res.data.data.users)
                setUsersToShow(res.data.data.users)
            })
            .catch(err=>{
                console.log(err.response)
            })
    }

    const handleAssignDataPoolToUsers = () => {
        if(selectedUsers.length === 0) return;
        setLoading(true)
        http.post(`data_connector/data_pool_handler/${state.connectorUid}/user_assignment/`,
          {
              to_users: selectedUsers,
              name: name,
              data_mapping: state.dataMapping,
          })
          .then(res => {
              setLoading(false)
              setStep(2)
              props.getData()
          })
          .catch(err=>{
              console.log(err.response)
              setLoading(false)
          })
    }

    const handleAssign = a => {
        setAssign(a)
        if(a === 'admin') setUsername('')
    }
    const handleSetTime = time => {
        setShowDatepicker(false)
        setDate(time.split(' '))
    }

    const handleSelectUser = e => {
        const selectedUsersList = [...selectedUsers]
        const findIndex = selectedUsers.findIndex(item => item === e.target.value)

        if (selectedUsers.length && findIndex !== -1) {
            selectedUsersList.splice(findIndex, 1)
        } else {
            selectedUsersList.push(e.target.value)
        }
        setSelectedUsers(selectedUsersList)
    }

    return (
        <div>
            <ConnectorHeader title="Upload File - Load Data">
                Congrats! You are here. The last step. Choose the person you want to assign this data connector to or if
                it’s yours, let’s load your data.
            </ConnectorHeader>
            <div className="d-flex mb-24">
                <div className="form mr-32">
                    <label>Select a Name</label>
                    <div className="d-flex align-items-center">
                        <input type="text" onChange={e => setName(e.target.value)}
                               placeholder="Enter a name for your data connector ..."/>
                        <div onClick={() => setStep(2)}
                             className={`${Styles.doneButton} ${name.length > 0 ? 'btn-active' : ''} btn btn-by-loading`}>
                            <p>Done</p>
                        </div>
                    </div>
                </div>
            </div>
            {step === 2 &&
            <>
                <HorizontalLine/>
                <div className={`d-flex justify-content-between ${Styles.SwitchBtn}`}>
                    <div style={assign === 'else' ? {left : 223 , width: 177} : undefined} className={Styles.ActiveBtn}></div>
                    <div onClick={() => handleAssign('admin')} className={`d-flex align-items-center ${Styles.item} ${assign === 'admin' ? Styles.active : ''}`}>
                        <svg className="mr-3" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_1938_1411"  maskUnits="userSpaceOnUse" x="3" y="12" width="14" height="7">
                                <path fillRule="evenodd" clipRule="evenodd" d="M3.3335 12.0806H16.5334V18.2256H3.3335V12.0806Z" fill="white"/>
                            </mask>
                            <g mask="url(#mask0_1938_1411)">
                                <path fillRule="evenodd" clipRule="evenodd" d="M9.93433 13.3306C6.3835 13.3306 4.5835 13.9406 4.5835 15.1447C4.5835 16.3597 6.3835 16.9756 9.93433 16.9756C13.4843 16.9756 15.2835 16.3656 15.2835 15.1614C15.2835 13.9464 13.4843 13.3306 9.93433 13.3306ZM9.93433 18.2256C8.30183 18.2256 3.3335 18.2256 3.3335 15.1447C3.3335 12.3981 7.101 12.0806 9.93433 12.0806C11.5668 12.0806 16.5335 12.0806 16.5335 15.1614C16.5335 17.9081 12.7668 18.2256 9.93433 18.2256Z" fill="#C2C7ED"/>
                            </g>
                            <mask id="mask1_1938_1411"  maskUnits="userSpaceOnUse" x="5" y="1" width="10" height="10">
                                <path fillRule="evenodd" clipRule="evenodd" d="M5.5083 1.66699H14.3583V10.5158H5.5083V1.66699Z" fill="white"/>
                            </mask>
                            <g mask="url(#mask1_1938_1411)">
                                <path fillRule="evenodd" clipRule="evenodd" d="M9.93416 2.8565C8.14999 2.8565 6.69833 4.30734 6.69833 6.0915C6.69249 7.86984 8.13333 9.31984 9.90999 9.3265L9.93416 9.9215V9.3265C11.7175 9.3265 13.1683 7.87484 13.1683 6.0915C13.1683 4.30734 11.7175 2.8565 9.93416 2.8565ZM9.93416 10.5157H9.90749C7.47249 10.5082 5.49999 8.52234 5.50833 6.089C5.50833 3.6515 7.49333 1.6665 9.93416 1.6665C12.3742 1.6665 14.3583 3.6515 14.3583 6.0915C14.3583 8.5315 12.3742 10.5157 9.93416 10.5157Z" fill="#C2C7ED"/>
                            </g>
                        </svg>
                        <span>Assign The Connector to Me</span>
                    </div>
                    <div onClick={() => handleAssign('else')} className={`d-flex align-items-center ${Styles.item} ${assign === 'else' ? Styles.active : ''}`}>
                        <svg className="mr-3" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M7.99268 12.6724C11.0668 12.6724 13.6943 13.1382 13.6943 14.999C13.6943 16.8599 11.0843 17.339 7.99268 17.339C4.91768 17.339 2.29102 16.8774 2.29102 15.0157C2.29102 13.154 4.90018 12.6724 7.99268 12.6724Z" stroke="#C2C7ED" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path fillRule="evenodd" clipRule="evenodd" d="M7.99289 10.0163C5.97456 10.0163 4.33789 8.38051 4.33789 6.36217C4.33789 4.34384 5.97456 2.70801 7.99289 2.70801C10.0104 2.70801 11.6471 4.34384 11.6471 6.36217C11.6546 8.37301 10.0296 10.0088 8.01872 10.0163H7.99289Z" stroke="#C2C7ED" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M13.7358 9.0679C15.07 8.8804 16.0975 7.7354 16.1 6.34956C16.1 4.98373 15.1042 3.8504 13.7983 3.63623" stroke="#C2C7ED" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M15.4961 12.2769C16.7886 12.4694 17.6911 12.9227 17.6911 13.856C17.6911 14.4985 17.2661 14.9152 16.5794 15.176" stroke="#C2C7ED" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>

                        Assign to Someone Else</div>
                </div>
                {
                    assign === 'admin' ?
                        <>
                            {/*<p className="f16 mt-24 fw700 dark-gary-2">This process will take about <span*/}
                            {/*    className="main-purple f20">2 Hours</span> to complete!</p>*/}
                            {/*<p className="fw400 f12 dark-gary-2 mt-2">You can start it right now or scedule for a precise time so we*/}
                            <p className="f12 mt-24 fw400 dark-gary-2">You can start it right now or scedule for a precise time so we
                                can start it for you. During this process you may want to do other works.</p>
                            <p className="fw500 f14 dark-gary mt-24">Schedule Data Loading</p>
                            <p className="fw400 f12 gray mt-2">We will start the job at the time you wantv</p>
                            <div className="d-flex mt-24">
                                {showDatepicker &&
                                <Datepicker
                                    showInput={false}
                                    handleSetDate={handleSetTime}
                                    style={{top: -296, left: 308}}
                                    dropdownOpenPosition={'left'}
                                />
                                }
                                <div onClick={() => setShowDatepicker(prevState => !prevState)} className={`mr-32 cursor-pointer ${Styles.inputDatepicker}`}>
                                    {date ?
                                        <span className="f12">{date[0].split('-')[0] + ' / ' + date[0].split('-')[1] + ' / ' + date[0].split('-')[2]}</span>
                                        :
                                        <span className="f12">-- / -- / --</span>
                                    }
                                    {date ?
                                        <span className="f12">    {date[1]}</span>
                                        :
                                        <span className="f12">    -- : -- : --</span>
                                    }

                                </div>
                                {/*<svg onClick={() => setShowDatepicker(prevState => !prevState)} className="mr-32 cursor-pointer" width="296" height="48" viewBox="0 0 296 48" fill="none"*/}
                                {/*     xmlns="http://www.w3.org/2000/svg">*/}
                                {/*    <rect width="296" height="48" rx="14" fill="#F0F2FF"/>*/}
                                {/*    <path*/}
                                {/*        d="M29.985 31.099V32.009H24.469V31.099H29.985ZM36.4381 31.099V32.009H30.9221V31.099H36.4381ZM42.2183 30.112C42.1529 30.2893 42.0503 30.42 41.9103 30.504C41.7703 30.5927 41.6256 30.637 41.4763 30.637H40.9023L45.0743 20.165C45.1396 20.0063 45.2329 19.885 45.3543 19.801C45.4803 19.7123 45.6249 19.668 45.7883 19.668H46.3693L42.2183 30.112ZM56.3444 31.099V32.009H50.8284V31.099H56.3444ZM62.7975 31.099V32.009H57.2815V31.099H62.7975ZM68.5776 30.112C68.5123 30.2893 68.4096 30.42 68.2696 30.504C68.1296 30.5927 67.985 30.637 67.8356 30.637H67.2616L71.4336 20.165C71.499 20.0063 71.5923 19.885 71.7136 19.801C71.8396 19.7123 71.9843 19.668 72.1476 19.668H72.7286L68.5776 30.112ZM82.7038 31.099V32.009H77.1878V31.099H82.7038ZM89.1569 31.099V32.009H83.6409V31.099H89.1569Z"*/}
                                {/*        fill="#70789E"/>*/}
                                {/*    <path*/}
                                {/*        d="M133.985 31.099V32.009H128.469V31.099H133.985ZM140.438 31.099V32.009H134.922V31.099H140.438ZM145.294 29.181C145.294 29.055 145.318 28.936 145.364 28.824C145.411 28.712 145.474 28.614 145.553 28.53C145.637 28.446 145.735 28.3807 145.847 28.334C145.959 28.2827 146.081 28.257 146.211 28.257C146.337 28.257 146.456 28.2827 146.568 28.334C146.68 28.3807 146.778 28.446 146.862 28.53C146.946 28.614 147.012 28.712 147.058 28.824C147.11 28.936 147.135 29.055 147.135 29.181C147.135 29.3117 147.11 29.433 147.058 29.545C147.012 29.657 146.946 29.755 146.862 29.839C146.778 29.923 146.68 29.9883 146.568 30.035C146.456 30.0817 146.337 30.105 146.211 30.105C146.081 30.105 145.959 30.0817 145.847 30.035C145.735 29.9883 145.637 29.923 145.553 29.839C145.474 29.755 145.411 29.657 145.364 29.545C145.318 29.433 145.294 29.3117 145.294 29.181ZM145.294 24.001C145.294 23.875 145.318 23.756 145.364 23.644C145.411 23.532 145.474 23.434 145.553 23.35C145.637 23.266 145.735 23.2007 145.847 23.154C145.959 23.1027 146.081 23.077 146.211 23.077C146.337 23.077 146.456 23.1027 146.568 23.154C146.68 23.2007 146.778 23.266 146.862 23.35C146.946 23.434 147.012 23.532 147.058 23.644C147.11 23.756 147.135 23.875 147.135 24.001C147.135 24.1317 147.11 24.253 147.058 24.365C147.012 24.477 146.946 24.575 146.862 24.659C146.778 24.743 146.68 24.8083 146.568 24.855C146.456 24.9017 146.337 24.925 146.211 24.925C146.081 24.925 145.959 24.9017 145.847 24.855C145.735 24.8083 145.637 24.743 145.553 24.659C145.474 24.575 145.411 24.477 145.364 24.365C145.318 24.253 145.294 24.1317 145.294 24.001ZM157.501 31.099V32.009H151.985V31.099H157.501ZM163.954 31.099V32.009H158.438V31.099H163.954Z"*/}
                                {/*        fill="#70789E"/>*/}
                                {/*    <path d="M267 21.5L260 28.5L253 21.5" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round"*/}
                                {/*          stroke-linejoin="round"/>*/}
                                {/*</svg>*/}
                                <div className={`${Styles.loadActions} d-flex align-items-center`}>
                                    <div onClick={() => sendDataPreview(true)} className={`${Styles.actionButton} ${loading1 && 'btn-loading-small'} btn btn-by-loading btn-active`}>
                                        <p>Schedule Data Loading</p>
                                        <p>Scheduling Data Loading</p>
                                    </div>
                                    <span className="mx-3">Or</span>
                                    <div onClick={() => sendDataPreview(false)} className={`${Styles.actionButton} ${loading && 'btn-loading-small'} btn btn-by-loading btn-outline btn-active`}>
                                        <p>Start Loading Right Now!</p>
                                        <p>Starting Loading Right Now!</p>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        <>
                            <p className="mt-24 mb-3 dark-gary-2 f14 fw500">Select the Person(s)</p>
                            {/*<SelectBox dropDownValue={username || 'select user'} style={{width:219,height:40}} optionsContainerWidth={219} optionsContainerHeight={200}>*/}
                            {/*    {users.map((user,key) => {*/}
                            {/*            if(user.is_active){*/}
                            {/*                return <div key={key} onClick={() => setUsername(user.username)}>{user.username}</div>*/}
                            {/*            }*/}
                            {/*        }*/}
                            {/*    )}*/}
                            {/*</SelectBox>*/}
                            <div className={Styles.assignToPersonsWrapper}>
                                <div aria-label="Select users" className={[Styles.button, showNameGroupsPopup && Styles.active].join(" ")} onClick={() => setShowNameGroupsPopup(!showNameGroupsPopup)}>
                                    <div className={Styles.names}>
                                        <div style={{width: selectedUsers.length > 1 && 95}}>
                                            {selectedUsers[0]}
                                        </div>
                                        <div>
                                            {
                                                selectedUsers.length > 1 && `, +${selectedUsers.length - 1} more`
                                            }
                                        </div>
                                    </div>
                                    <i>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.0835 4.16683L12.9168 10.0002L7.0835 15.8335" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </i>
                                </div>
                                {
                                    showNameGroupsPopup &&
                                        <div ref={myRef} className={Styles.namesGroupPopup}>
                                            <input type={"search"} className={Styles.searchInput} onChange={handleSearchUsers} />
                                            {usersToShow.map((user,key) => {
                                                  return <label className={Styles.bContain} onChange={handleSelectUser}>
                                                      <span>{user}</span>
                                                      <input className={selectedUsers.some(item => item === user) && Styles.checked} type="checkbox" value={user} />
                                                      <div className={Styles.bInput}>

                                                      </div>
                                                  </label>
                                              }
                                            )}
                                            <Button onClick={() => setSelectedUsers([])} block type={"outlined"} color={"primary"} size={"small"}>
                                                Clear All
                                            </Button>
                                        </div>
                                }
                            </div>
                        </>

                }
            </>
            }
            <div onClick={handleAssignDataPoolToUsers} style={{position:"absolute",bottom:32,width:'100%',right:32}} className="d-flex justify-content-end">
                <div className={`btn mb-0 mt-3 ${(selectedUsers.length && !loading) ? '' : 'btn-disable'}`}>{loading ? "Processing..." : "Finish"}</div>
            </div>
        </div>
    )
}
export default LoadData;
